module.exports = require('./parseEmbedCode')
